import {fetchSync, useCart, useQuery} from '@shopify/hydrogen';
import {useTransition} from 'react';
import {getSkusAndQuantitiesFromLines} from '../../lib/hatcherybrain';

export function useHatcheryBrainCart() {
  const {lines} = useCart();

  if (!lines || lines.length === 0) {
    return;
  }

  const cartObject = getSkusAndQuantitiesFromLines(lines);

  const response = fetchSync('https://apiv2.hatcherybrain.com/feed/cart', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(cartObject),
  }).json();

  return response;
}

type CartLine = {
  sku: string;
  qty: number;
};

export function useCackleHatcheryCartUrl() {
  const {lines} = useCart();

  if (!lines || lines.length === 0) {
    return;
  }

  const cartObject = getSkusAndQuantitiesFromLines(lines);
  const cartArray: CartLine[] = [];
  Object.keys(cartObject).forEach((key) => {
    const lineItem = {
      sku: key,
      qty: cartObject[key],
    };
    cartArray.push(lineItem);
  });

  const encodedString = encodeURIComponent(JSON.stringify(cartArray))
    .replace(/'/g, '%27')
    .replace(/"/g, '%22');

  const urlWithParams = new URL(
    'https://www.cacklehatchery.com/wp-json/hatcherybrain/smartcart',
  );
  urlWithParams.searchParams.append('cart', JSON.stringify(cartArray));

  return urlWithParams.toString();
}
